export default "__VITE_ASSET__qCrdXyxN__"